export default "__VITE_ASSET__DcGiOZvf__"